import { createContext } from 'react'

const DocumentGenerateContext = createContext()

export default DocumentGenerateContext
